import "./App.scss";
import "./misc/main.scss";
import "./misc/pb-tailwind.scss";

import NavBar from "./component/NavBar";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import EventDetailPage from "./pages/EventDetailPage";
import ResultPage from "./pages/ResultPage";
import DonationPage from "./pages/DonationPage";
import DonationResultPage from "./pages/DonationResultPage";
import ConfirmationPage from "./pages/ConfirmationPage";
import QRCodePage from "./pages/QRCodePage";
import RecurringManagePage from "./pages/RecurringManagePage";

import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers";

const App = () => {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <div className="App">
        <NavBar />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<EventDetailPage />}>
              <Route path=":id" element={<EventDetailPage />} />
            </Route>
            <Route path="/donation" element={<DonationPage />} />
            <Route path="/donation/:id" element={<DonationResultPage />} />
            {/* donor self-service cancel page */}
            <Route path="/recurring" element={<RecurringManagePage />} />
            <Route path="/confirmation/:type" element={<ConfirmationPage />} />
            <Route path="/payment/:type" element={<QRCodePage />} />
            <Route path="/result/:id" element={<ResultPage />} />
          </Routes>
        </BrowserRouter>
      </div>
    </LocalizationProvider>
  );
};

export default App;
